@layer module {
.recurring-edit-hint {
            margin: 0;
    }

.recurring-edit-actions {
            width: 100%;
            display: flex;
            flex-flow: row wrap;
            justify-content: flex-end;
    }
} // layer module










@layer app {
.recurring-edit-actions {
            gap: $size-12;
    }

.recurring-edit-hint {
            color: var(--text-secondary);
            font-size: var(--font-size-base);
    }
} // layer app
